import {Component, OnInit, ViewChild} from '@angular/core';
import {HistoricTrafficTimeBuckets, TravelBoundaryComponent} from '../travel-boundary/travel-boundary.component';
import {RouteComponent} from '../route/route.component';
import {NgbTabChangeEvent} from '@ng-bootstrap/ng-bootstrap';

import {RoutingDemoPageService} from '../services/routing-demo-page-service';
import {ErrorDialogService} from '../services/error-dialog.service';
import {RoutingDatabaseService} from '../services/routing-database-service';

export enum appTimeOutRange  {
  'CNT' = '0',
  MAX = 10000,
  WAIT =  1000
}

@Component({
  selector: 'app-maincomponent',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  @ViewChild(TravelBoundaryComponent, {static: false}) tb;
  @ViewChild(RouteComponent, {static: false}) rc;
   selectedTab: string;
  constructor(private routingDemoPageService: RoutingDemoPageService,
              private errorDialogService: ErrorDialogService, private routingDatabaseService: RoutingDatabaseService) {
    this.routingDemoPageService.init();
  }
  showCredentialsDiv: boolean;
  showOptionsDiv: boolean;
  showChangeUserButton: boolean;
  showDB: boolean;
  isApplyButtonDisabled: boolean;
  submitted: boolean;
  username: string;
  password: string;
  dbNames: any;
  selectedDBName: any;
  ngOnInit() {
    this.init();
  }
  onTabChangeEvent(event: NgbTabChangeEvent) {
    this.selectedTab = event.nextId;
    if (this.selectedTab === 'tab2') {
      this.rc.setMapContentForRoute();
    }
    if (this.selectedTab === 'tab1') {
      this.tb.setMapContentForBoundary();
    }
  }






  init() {
    this.routingDemoPageService.getDataRJS().subscribe((response: any) => {
      this.showCredentialsDiv = false;
      this.showOptionsDiv = false;
      this.showChangeUserButton = false;
      this.showDB = false;
      this.isApplyButtonDisabled = false;
      response.env = this.routingDemoPageService.getEnv();
      if (appTimeOutRange.CNT > appTimeOutRange.MAX) {
        this.errorDialogService.showErrorDialog('Configuration file not found.');
      }
      if (!response.env) {
        /*appTimeOutRange.CNT += appTimeOutRange.WAIT;*/
        setTimeout(this.init, appTimeOutRange.WAIT);
      }
      if (response.env === 'erm') {
        this.showCredentialsDiv = true;
      } else if (response.env === 'rjs') {
        this.showOptionsDiv = true;
        /* setTimeout (appTimeOutRange.WAIT);*/
      }
    });
    this.routingDemoPageService.getDataERM().subscribe((responseErm: any) => {
      this.showCredentialsDiv = false;
      this.showOptionsDiv = false;
      this.showChangeUserButton = false;
      this.showDB = false;
      this.isApplyButtonDisabled = false;
      responseErm.env = this.routingDemoPageService.getEnv();
      if (appTimeOutRange.CNT > appTimeOutRange.MAX) {
        this.errorDialogService.showErrorDialog('Configuration file not found.');
      }
      if (!responseErm.env) {
        /*appTimeOutRange.CNT += appTimeOutRange.WAIT;*/
        setTimeout(this.init, appTimeOutRange.WAIT);
      }
      if (responseErm.env === 'erm') {
        this.showCredentialsDiv = true;
      } else if (responseErm.env === 'rjs') {
        this.showOptionsDiv = true;
        /* setTimeout (appTimeOutRange.WAIT);*/
      }
    });
  }
  showCredentialsView() {
    this.showCredentialsDiv = true;
    this.showChangeUserButton = false;
    this.submitted =  false;
  }

  runDBService(isFormValid) {
    this.submitted =  true;
    if (isFormValid) {
      this.routingDatabaseService.getDBNames(this.username, this.password).subscribe(response => {
        if (response) {
          this.showDB = true;
          this.showOptionsDiv = true;
          this.showCredentialsDiv = false;
          this.showChangeUserButton = true;
          this.dbNames = response;
          if (response.length > 0) {
            const arrayObjects = [];
            for (let [propertyKey, propertyValue] of Object.entries( this.dbNames)) {
              propertyValue = this.dbNames[propertyKey].name;
              arrayObjects.push({ id: propertyKey, name: propertyValue });
            }
            this.dbNames = arrayObjects;
            this.selectedDBName =  this.dbNames[0].name;
          } else {
            this.selectedDBName = '';
          }
        } else {
          this.showDB = false;
          this.showOptionsDiv = false;
          this.showChangeUserButton = false;
        }
      }, (errorRes) => {
        if (errorRes.message != null) {
          this.errorDialogService.showErrorDialog('Invalid User Name or Password. Please provide valid credentials.');
        }
      });
    }
  }
  onChangeDatabase(event: any) {
    const value = this.selectedDBName;
    this.selectedDBName = value;
  }
}
